module.exports = __webpack_public_path__ + "media/images/athletes/250-bf9f78548ce26272f3b27e548d519084.png";